require('../../modules/es.array.map');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'map');
